import { Injectable } from '@angular/core';
//import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { NotificationsService } from 'angular2-notifications';

const EXCEL_EXTENSION = '.xlsx';


@Injectable({
  providedIn: 'root'
})
export class ExportExcelService {

  constructor(
    private notificationService: NotificationsService,
  ) { }


  exportXlsx(rowData: Array<any>, columns?:Array<any>, fileName?: string) {
    if (rowData !== null && rowData.length > 0) {
      //Se não passar nome como parametro entao seta nome default para CSV_FILE
      fileName = fileName!=null && fileName.trim()!=''?fileName:'CSV_FILE';
      
      //Pega o header padrão
      let header = Object.keys(rowData[0]);

      //Renomeia o header padrão caso o mesmo seja passado como parâmetro(columns)
      this.replaceColumns(header,columns);

      let rowXlsx: Array<any> = Object.assign([], rowData);
      let listRows: Array<any> = [];
      listRows.push(header);
      rowXlsx.forEach(data => {
        let line: Array<any> = [];
        Object.keys(data).forEach(key => {
          line.push(data[key]);
        });
        listRows.push(line);
        });

      let ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(listRows);
      let wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, fileName);

        // save to file
      XLSX.writeFile(wb, fileName + EXCEL_EXTENSION);
    } else {
      this.notificationService.warn('Não há dados para exportar!');
    }
  }

  replaceColumns(header:any, columns?:Array<any>){
    if(columns){
      columns.forEach((column)=>{
        let index = header.indexOf(column.columnName)
        if(index!=-1){
          header[index]=column.newColumnName
        }
      })
    }
  }

}
